<ion-content class="ion-padding">

  @for (readState of readStates; track readState) {
    <div class="read-item">
      <h3>{{readState.employee?.firstName}} {{readState.employee?.lastName}}</h3>
      <div class="time">{{dayjs(readState.readDate).fromNow()}}</div>
    </div>
  }

</ion-content>